module.exports = __webpack_public_path__ + "assets/icon-plannings.b44407e3.svg";